import { FadeUp, Overline } from "@/components/Reveal";

const Privacy = () => (
  <section data-testid="privacy-page" className="py-20 sm:py-28">
    <div className="max-w-3xl mx-auto px-5 sm:px-8">
      <FadeUp>
        <Overline>Legal</Overline>
        <h1 className="mt-6 font-serif text-4xl sm:text-5xl font-medium tracking-tight text-ink">
          Privacy Policy
        </h1>
        <div className="mt-10 space-y-6 text-base leading-relaxed text-mute">
          <p className="text-sm text-mute/70">Last updated: July 2026</p>
          <p>
            This website is operated by Jocelyn MacDonald (Empress Coaching &amp; Consulting). It's a
            personal brand site, not a data-harvesting operation — here's the plain-language version of
            what that means.
          </p>
          <h2 className="font-serif text-2xl font-medium text-ink pt-4">What I collect</h2>
          <p>
            If you fill out the contact form, I receive whatever you choose to share: your name, email,
            company or organization, the topic you select, and your message. That's it. This information
            is used for one purpose only — so Jocelyn can read your message and reply to you.
          </p>
          <h2 className="font-serif text-2xl font-medium text-ink pt-4">What I don't do</h2>
          <p>
            I don't sell your information, rent it, trade it, or add you to a marketing list you didn't
            ask for. There is no newsletter to accidentally end up on.
          </p>
          <h2 className="font-serif text-2xl font-medium text-ink pt-4">Analytics</h2>
          <p>
            This site uses basic, privacy-respecting analytics to understand which pages people find
            useful. No personal profiles are built from it.
          </p>
          <h2 className="font-serif text-2xl font-medium text-ink pt-4">Questions</h2>
          <p>
            If you'd like to know what information I hold about you, or you'd like it deleted, use the
            contact form and ask. A human being (Jocelyn) will handle it.
          </p>
        </div>
      </FadeUp>
    </div>
  </section>
);

export default Privacy;
